import { FilterType, type Filter } from '../types/filter'
import { getCountryName } from './countries'

export function isFilterActive(filter: Filter): boolean {
    const v = filter.value
    if (v == null) return false
    if (Array.isArray(v)) return v.length > 0
    if (filter.key === FilterType.age) return v.min != null || v.max != null
    if (filter.key === FilterType.country) return Array.isArray(v.values) && v.values.length > 0
    if (filter.key === FilterType.date) return !!(v.start || v.end)
    return true
}

function joinLabels(labels: string[], max = 2): string {
    const shown = labels.slice(0, max).join(', ')
    const extra = labels.length > max ? ` +${labels.length - max}` : ''
    return `${shown}${extra}`
}

const STATUS_LABELS: Record<string, string> = { active: 'Active', expired: 'Expired', unsubscribed: 'Unsubscribed' }

export function filterChipSummary(filter: Filter): string {
    const v = filter.value
    switch (filter.key) {
        case FilterType.age: {
            const min = v?.min
            const max = v?.max
            if (min != null && max != null) return `Age: ${min}–${max} yrs`
            if (min != null) return `Age: > ${min} yrs`
            if (max != null) return `Age: < ${max} yrs`
            return 'Age'
        }
        case FilterType.gender:
            return `Gender: ${joinLabels((v ?? []).map((g: string) => (g === 'male' ? 'Male' : 'Female')))}`
        case FilterType.country: {
            const names = (v?.values ?? []).map((c: string) => getCountryName(c))
            return `Country: ${v?.exclude ? 'Not in: ' : ''}${joinLabels(names)}`
        }
        case FilterType.subscriptionStatus:
            return `Status: ${joinLabels((v ?? []).map((s: string) => STATUS_LABELS[s] ?? s))}`
        case FilterType.partner: {
            const names = Array.isArray(filter.selected) ? filter.selected.map((p: any) => p.name) : null
            return `Partner: ${names?.length ? joinLabels(names) : `${(v ?? []).length} selected`}`
        }
        case FilterType.policyHolder:
            return `Policy: ${joinLabels(v ?? [])}`
        case FilterType.customerTag:
            return `Tag: ${joinLabels(v ?? [])}`
        case FilterType.callSource:
        case FilterType.callStatus:
        case FilterType.callDecision:
            return `${filter.label}: ${joinLabels((Array.isArray(filter.selected) ? filter.selected : []).map((s: any) => s.name))}`
        case FilterType.date:
            if (v?.start && v?.end) return `Date: ${v.start} – ${v.end}`
            if (v?.start) return `Date: after ${v.start}`
            if (v?.end) return `Date: before ${v.end}`
            return filter.label
        case FilterType.switchedCalls:
            return `Non-member switches: ≥ ${v}`
        default:
            return `${filter.label}${filter.selected?.name ? `: ${filter.selected.name}` : ''}`
    }
}
